import { render, staticRenderFns } from "./langSelection.vue?vue&type=template&id=c83b140c&"
import script from "./langSelection.vue?vue&type=script&lang=js&"
export * from "./langSelection.vue?vue&type=script&lang=js&"
import style0 from "./langSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports